"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.pass_reset.subject': 'Żądanie Resetowania Hasła',
    'email.pass_reset.title': 'Zresetuj Swoje Hasło',
    'email.pass_reset.text': 'Poprosiłeś o zresetowanie swojego hasła. Kliknij przycisk poniżej, aby ustawić nowe hasło.',
    'email.pass_reset.button': 'Zresetuj Hasło',
};
